import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "../styles/hero.css";
import image from "../assets/map.png";
import hero1 from "../assets/hero1.png";
import hero2 from "../assets/hero2.png";
import hero3 from "../assets/hero3.jpeg";
import BookDemo from "./BookDemo.js";

export default function HeroSlider() {
  const [openModal, setOpenModal] = useState(false);
  const [current, setCurrent] = useState(0);
  const [isHovering, setIsHovering] = useState(false);

  const navigate = useNavigate(); // ✅ ADD THIS

  const slides = [
    {
      img: hero1,
      title: "Empowering Minds, Shaping Futures for a Brighter Tomorrow",
      desc: "Revolutionising Education by Nurturing 4Cs - Creativity, Critical Thinking, Communication and Collaboration",
    },
    {
      img: hero2,
      title: "Empower Your Career With Sprout's 4C Framework",
      desc: "AI/ML | Full Stack | Space Tech | Cloud Computing | Web Development | Python | Java | App Development | Data Science | HTML, CSS | C, C++ | JavaScript | Node JS | React | Angular | UI/UX Design | Power BI | Prompt Engineering.",
    },
    {
      img: hero3,
      title: "400+ Bankers Placed",
      desc: (
        <div className="banking-hero-content">
          <div className="banking-subtitle">
            We empower students to kickstart{" "}
            <span className="highlight-text">Banking Careers</span>{" "}
            in both government and private sectors through our comprehensive
            training and placement programs.
          </div>

          <div className="banking-actions">
            <button
              className="btn dark"
              onClick={() => navigate("/syllabus")} // ✅ WORKS
            >
              Know more
            </button>
          </div>
        </div>
      ),
    },
    {
      img: image,
      title: "Global Reach",
      desc: "India | Australia | Kenya | US | Qatar | KSA | France | Germany | Thailand | Singapore | Malaysia",
    },
  ];

  // 🔁 AUTO SLIDE (pauses on hover)
  useEffect(() => {
    if (isHovering) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [isHovering, slides.length]);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  return (
    <>
      <section
        className="choco-hero"
        style={{ backgroundImage: `url(${slides[current].img})` }}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <div className="choco-overlay"></div>

        <div className="choco-content">
          <h1 className="choco-title">{slides[current].title}</h1>

          <div className="choco-right">
            <div className="choco-desc">{slides[current].desc}</div>

            <div className="choco-button-wrapper">
              <button className="choco-btn" onClick={() => setOpenModal(true)}>
                Book a Demo
              </button>
            </div>
          </div>
        </div>

        {/* LEFT ARROW */}
        <button className="hero-arrow left" onClick={prevSlide}>
          &#10094;
        </button>

        {/* RIGHT ARROW */}
        <button className="hero-arrow right" onClick={nextSlide}>
          &#10095;
        </button>

        {/* DOTS */}
        <div className="hero-dots">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`hero-dot ${current === index ? "active" : ""}`}
              onClick={() => setCurrent(index)}
            ></span>
          ))}
        </div>
      </section>

      {openModal && (
        <BookDemo isOpen={openModal} onClose={() => setOpenModal(false)} />
      )}
    </>
  );
}
